var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"box content wspace-preline",domProps:{"innerHTML":_vm._s(_vm.finalComment)}})}
var staticRenderFns = []

export { render, staticRenderFns }